import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { FormsModule } from '@angular/forms';
import { APP_BASE_HREF } from '@angular/common';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { provideRouter, RouterModule } from '@angular/router';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  ButtonComponent,
  PolifunzioneLibModule,
} from '@poliblend/polifunzione-lib';
import { environment } from 'src/environments/environment';
import { routes } from './app.routes';
import { ItSpinnerComponent } from 'design-angular-kit';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    WelcomePageComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    RouterModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    ButtonComponent,
    ItSpinnerComponent,
    FormsModule,
    LoggerModule.forRoot({
      level: NgxLoggerLevel.TRACE,
      serverLogLevel: NgxLoggerLevel.ERROR,
      disableConsoleLogging: false,
    }),
    PolifunzioneLibModule.forRoot(environment),
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/authenticator' },
    provideAnimationsAsync(),
    provideRouter(routes),
  ],
})
export class AppModule {}
